import { Abstrap } from '..';

const { propTypes } = Abstrap;

const defaultProps = { ...Abstrap.defaultProps, componentClass: 'div' };

class Pagination extends Abstrap {

    getClassNameSchema() {
        const {
            className,
        } = this.props;
        return [
            'c-pagination',
            className,
        ];
    }

}

Pagination.propTypes = propTypes;

Pagination.defaultProps = defaultProps;

export default Pagination;
